/// <amd-module name="VSSUI/InfoIcon" />
export * from "./Components/InfoIcon/index";
